import { z } from 'zod';

export const MaterialSchema = z.object({
  id: z.string().uuid(),
  project_id: z.string().uuid(),
  category: z.string(),
  name: z.string(),
  specification: z.string().nullable(),
  location: z.string().nullable(),
  unit: z.string().default('m²'),
  quantity: z.number().nullable(),
  notes: z.string().nullable(),
  ai_extracted: z.boolean().default(true),
  overridden: z.boolean().default(false),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateMaterialSchema = z.object({
  category: z.string().min(1, 'Category is required'),
  name: z.string().min(1, 'Material name is required'),
  specification: z.string().optional(),
  location: z.string().optional(),
  unit: z.string().default('m²'),
  quantity: z.number().optional(),
  notes: z.string().optional(),
});

export const UpdateMaterialSchema = z.object({
  category: z.string().min(1).optional(),
  name: z.string().min(1).optional(),
  specification: z.string().nullable().optional(),
  location: z.string().nullable().optional(),
  unit: z.string().optional(),
  quantity: z.number().nullable().optional(),
  notes: z.string().nullable().optional(),
  overridden: z.boolean().optional(),
});

export type Material = z.infer<typeof MaterialSchema>;
export type CreateMaterial = z.infer<typeof CreateMaterialSchema>;
export type UpdateMaterial = z.infer<typeof UpdateMaterialSchema>;
